import * as destinationDeliveryService from "../../../../services/destinationDelivery";
import * as settings from "../../../../services/settings";

import {
  Breadcrumb,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Spin,
  Tabs,
  Typography,
  notification,
} from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  validateCreateDestinationDelivery,
  validateSubmitCreateDestinationDelivery,
} from "../../../../Components/validations/validateCreateDestinationDelivery";

import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import ContentType from "../../../../../configs/contentType";
import permissions from "../../../../../configs/permission";
import BtnHistory from "../../../../Components/model/button/history";
import { CreateDestinationDeliveryPackage } from "../../../../Components/package/destinationdelivery/destinationDeliveryPackage";
import { useAccessToken } from "../../../../contexts/AccessTokenContext";
import { usePermission } from "../../../../hooks/usePermission";

const { TextArea } = Input;
const { Title } = Typography;

export const DestinationDeliveryCreatePage = () => {
  const { hasPermission, isSuperuser } = usePermission();
  const { t } = useTranslation("destinationdelivery", "buttons", "common");
  const { t: tOps } = useTranslation("options", { keyPrefix: "Package" });
  const { accessToken } = useAccessToken();
  const [formDestinationDelivery] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isDisable, setIsDisable] = useState(true);
  const [isCreate, setIsCreate] = useState(false);
  const [isHiddenBtnCreate, setIsHiddenBtnCreate] = useState(false);
  const [isCheckCreateSuccess, setIsCreateSuccess] = useState(false);
  const [dataDestinationDelivery, setDataDestinationDelivery] = useState([]);
  const [_, setDepartAt] = useState();
  const location = useLocation();
  const data = location.state;
  const navigation = useNavigate();
  // Validate field is required
  const [validateFieldRequired, setValidateFieldRequired] = useState({
    fieldVehicle: false,
    fieldDepartAt: false,
  });

  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message: message,
      description: description,
    });
  };

  // eslint-disable-next-line arrow-body-style
  const disabledDate = (current) => {
    // Can not select days before today and today
    return current && current <= dayjs().add(-1, "days").endOf("day");
  };

  const disabledDateTime = (current) => {
    // Allow all times when the selected date is not today
    if (!current || !current.isSame(dayjs(), "day")) {
      return {};
    }

    const now = dayjs();
    const currentHour = now.hour();
    const currentMinute = now.minute();

    return {
      disabledHours: () => {
        const hours = [];
        for (let i = 0; i < 24; i++) {
          // Disable hours strictly before the current hour
          if (i < currentHour) {
            hours.push(i);
          }
        }
        return hours;
      },
      disabledMinutes: (selectedHour) => {
        // When the selected hour is the current hour, disable minutes
        // that are less than or equal to the current minute
        if (selectedHour === currentHour) {
          const minutes = [];
          for (let i = 0; i < 60; i++) {
            if (i <= currentMinute) {
              minutes.push(i);
            }
          }
          return minutes;
        }
        return [];
      },
    };
  };

  const setDetailData = (detailData) => {
    if (!detailData) return;
    formDestinationDelivery.setFieldValue("vehicle", detailData.vehicle ?? "");
    formDestinationDelivery.setFieldValue("depart_at", detailData.depart_at ? dayjs(detailData.depart_at) : undefined);
    formDestinationDelivery.setFieldValue("delivery_type", detailData.delivery_type ?? undefined);
    formDestinationDelivery.setFieldValue("delivery_status", detailData.delivery_status ?? undefined);
    formDestinationDelivery.setFieldValue("note", detailData.note ?? "");
  };

  const validateDataDestinationDeliveryRequired = async (name, value) => {
    await validateCreateDestinationDelivery(validateFieldRequired, setValidateFieldRequired, name, value);
  };

  const onClickedTab = (data) => {
    if (data !== "1") {
      setIsHiddenBtnCreate(true);
    } else {
      setIsHiddenBtnCreate(false);
    }
  };

  const onOk = (value) => {
    setDepartAt(value);
  };

  const onSubmit = async () => {
    const values = await formDestinationDelivery.getFieldsValue();
    const { vehicle, depart_at, delivery_type, delivery_status, note } = values || {};
    const { isValid } = validateSubmitCreateDestinationDelivery(values, data);
    if (isValid) {
      const prepareDestinationDelivery = {
        vehicle: vehicle || "",
        depart_at: depart_at || "",
        delivery_type: delivery_type || "NORMAL",
        delivery_status: delivery_status || "open",
        note: note || "",
      };
      setLoading(true);
      try {
        if (data.type === "CREATE") {
          const response = await destinationDeliveryService.createDestinationDelivery(
            accessToken,
            prepareDestinationDelivery
          );
          if (response !== null || response != undefined) {
            openNotificationWithIcon(
              settings.NotificationType.SUCCESS,
              <>{"Success."}</>,
              <>{"Create destination delivery success"}</>
            );
            setIsCreateSuccess(true);
            const createdDetail = await destinationDeliveryService.getDestinationDeliveryById(accessToken, response.id);
            setLoading(false);
            setIsDisable(false);
            setDetailData(createdDetail);
            setIsCreate(true);
            setDataDestinationDelivery(createdDetail || response);
          }
        } else {
          const prepareEditDataDeliveryData = {
            id: data.destinationDeliveryData.id,
            ...prepareDestinationDelivery,
          };
          const response = await destinationDeliveryService.updateDestinationDelivery(
            accessToken,
            prepareEditDataDeliveryData
          );
          if (response !== null || response != undefined) {
            setLoading(false);
            openNotificationWithIcon(
              settings.NotificationType.SUCCESS,
              <>{"Success."}</>,
              <>{"Update destination delivery success"}</>
            );
          }
        }
      } catch (err) {
        console.error("[DestinationDeliveryCreatePage] onSubmit: ", err);
        const { message } = settings.getErrorMessage(err);
        openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
        setLoading(false);
      }
    } else {
      openNotificationWithIcon(
        settings.NotificationType.ERROR,
        <>{"ERROR."}</>,
        <>{`Please check data is request create/update destination delivery or Depart at not equal time now`}</>
      );
      setLoading(false);
    }
  };

  const items = [
    { title: t("Page_Body_Tab_Menu.Home", { ns: "menus" }) },
    { title: t("Page_Body_Tab_Menu.Menu", { ns: "menus" }) },
    { title: <a href="/package/destinationdelivery">{t("Title_Destination_Delivery")}</a> },
    { title: <a style={{ fontWeight: 600, color: "black" }}>{t("Destination_Delivery_Create.Title")}</a> },
  ];

  useEffect(() => {
    if (!accessToken) {
      setLoading(false);
      return;
    }
    if (data?.type === "EDIT") {
      setDetailData(data.destinationDeliveryData);
      setIsDisable(false);
      setIsCreateSuccess(false);
    }
  }, [accessToken, data?.type, data?.destinationDeliveryData?.id]);

  const initialItems = [
    {
      label: t("Destination_Delivery_Create.Create_Destination_Delivery_Package.Title_Package"),
      children: (
        <CreateDestinationDeliveryPackage
          t={t}
          type={data.type}
          detailData={isCreate ? dataDestinationDelivery : data.destinationDeliveryData}
          accessToken={accessToken}
          isCreate={!isCreate}
          setIsCreate={setIsCreate}
        />
      ),
      key: "1",
    },
  ];

  const selectDeliveryType = [
    { value: "NORMAL", label: tOps("Delivery_Type.Normal") },
    { value: "SELF", label: tOps("Delivery_Type.Self") },
    { value: "PRIVATE", label: tOps("Delivery_Type.Private") },
    { value: "EXPRESS", label: tOps("Delivery_Type.Express") },
  ];

  return (
    <>
      {contextHolder}
      <Spin spinning={loading}>
        <Row style={{ overflowX: "auto" }}>
          <Col span={24}>
            <Breadcrumb items={items} />
            <div className="flex justify-between mt-6 mb-4">
              <Title level={2}>{t("Destination_Delivery_Create.Title")}</Title>
              {data?.type === "EDIT" && (
                <BtnHistory
                  titleRef={data?.destinationDeliveryData?.vehicle}
                  object_id={data?.destinationDeliveryData?.id}
                  content_type_id={[ContentType.DestinationDelivery, ContentType.DestinationDeliveryImage]}
                />
              )}
            </div>
          </Col>
          <Col span={22} style={{ minWidth: 640 }}>
            <Form form={formDestinationDelivery} labelAlign="left" labelCol={{ flex: "140px" }}>
              <Row gutter={12}>
                <Col span={8} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Destination_Delivery_Create.Vehicle_Type") + ":"}
                    name="vehicle"
                    style={{ marginBottom: "1rem" }}
                    rules={[{ required: true }, { validator: validateDataDestinationDeliveryRequired }]}
                    hasFeedback
                  >
                    <Input
                      size="default"
                      placeholder={t("Destination_Delivery_Create.Vehicle_Type")}
                      style={{ minWidth: 200 }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={8} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Destination_Delivery_Create.Depart_At") + ":"}
                    name="depart_at"
                    style={{ marginBottom: "1rem" }}
                    rules={[{ required: true }, { validator: validateDataDestinationDeliveryRequired }]}
                    hasFeedback
                  >
                    <DatePicker
                      style={{ width: "100%", minWidth: 200 }}
                      disabledDate={disabledDate}
                      disabledTime={disabledDateTime}
                      showTime
                      onOk={onOk}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={8} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Destination_Delivery_Create.Delivery_Type") + ":"}
                    name="delivery_type"
                    style={{ marginBottom: "1rem" }}
                  >
                    <Select
                      style={{ width: "100%", minWidth: 200 }}
                      placeholder={t("Destination_Delivery_Create.Delivery_Type")}
                      options={selectDeliveryType}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={8} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Destination_Delivery_Create.Delivery_Status") + ":"}
                    name="delivery_status"
                    style={{ marginBottom: "1rem" }}
                    hasFeedback
                  >
                    <Input
                      size="default"
                      disabled
                      value={"OPENED"}
                      placeholder={t("Destination_Delivery_Create.Delivery_Status")}
                      style={{ minWidth: 200 }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={8} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Destination_Delivery_Create.Note") + ":"}
                    name="note"
                    style={{ marginBottom: "1rem" }}
                  >
                    <TextArea allowClear={true} rows={4} style={{ minWidth: 200 }} />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
        <Row align="middle" justify="center">
          <Col span={24}>
            <Card>
              <Tabs type="card" items={initialItems} onChange={onClickedTab} />
            </Card>
          </Col>
        </Row>
        {isHiddenBtnCreate === false ? (
          <Row align="middle" justify="end" style={{ marginTop: "20px" }}>
            {(data?.type === "CREATE" && hasPermission(permissions.DestinationDelivery.ADD)) ||
            (data?.type === "EDIT" && hasPermission(permissions.DestinationDelivery.CHANGE)) ? (
              <Button
                type="primary"
                disabled={
                  data.type === "CREATE"
                    ? validateFieldRequired.fieldVehicle && validateFieldRequired.fieldDepartAt
                      ? isCheckCreateSuccess
                        ? true
                        : false
                      : true
                    : false
                }
                onClick={onSubmit}
                style={{ marginRight: "10px" }}
              >
                {t("BTN_Save", { ns: "buttons" })}
              </Button>
            ) : null}
            <Button
              type="default"
              onClick={() => {
                navigation("/package/destinationdelivery");
              }}
            >
              {t("BTN_Cancel", { ns: "buttons" })}
            </Button>
          </Row>
        ) : (
          ""
        )}
      </Spin>
    </>
  );
};
